module.exports = __webpack_public_path__ + "img/客服码.0d7eb58c.png";